import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  http: HttpClient = inject(HttpClient);
  constructor() { }

  async getAllPosts(type: string) {
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/blog/${type}`)
        .subscribe({
          next: data => resolve(data),
          error: err => console.log(err)
        })
    })
  }

  async getPost(id: string) {
    return new Promise(resolve => {
      this.http.get(`${environment.apiUrl}/blog/post/${id}`)
        .subscribe({
          next: data => resolve(data),
          error: err => console.log(err)
        })
    })
  }
}
